var Form = {
  // btn01用のオブジェクト

  init:function () {
    this.$input = $('.js-input-type-file');
    this.clearFile();
    this.change();
  },

  change: function() {

    this.$input.on('change',function(e){
      var files = e.target.files;
      var txtTarget;
      var imgTarget;

      if($(e.currentTarget).is('#store-img-input')){
        imgTarget = $('#store-holder').find('.img-holder-inner');
        txtTarget = $('#store-holder').find('.c-form-input-txt');
        $('#store-img-clear-btn').addClass('is-active');
      } else if($(e.currentTarget).is('#collection-img-input')){
        $('#collection-img-clear-btn').addClass('is-active');
        imgTarget = $('#collection-holder').find('.img-holder-inner');
        txtTarget = $('#collection-holder').find('.c-form-input-txt');
      }

      for (var i = 0, f; f = files[i]; i++) {

        // Only process image files.
        if (!f.type.match('image.*')) {
          continue;
        }

        var reader = new FileReader();

        // Closure to capture the file information.
        reader.onload = (function(theFile) {
          return function(e) {
            $(txtTarget).text(escape(theFile.name));
            $(imgTarget).empty();
            $(imgTarget).append('<img src="'+ e.target.result +'">');
          };
        })(f);

        // Read in the image file as a data URL.
        reader.readAsDataURL(f);
      }
    });
  },

  clearFile: function() {
    $('#store-img-clear-btn').on('click',function(){
      $('#store-img-input').replaceWith($('#store-img-input').clone(true));
      $('#store-holder').find('.img-holder-inner').empty();
      $('#store-holder').find('.c-form-input-txt').text('');
      $(this).removeClass('is-active');
    });

    $('#collection-img-clear-btn').on('click',function(){
      $('#collection-img-input').replaceWith($('#collection-img-input').clone(true));
      $('#collection-holder').find('.img-holder-inner').empty();
      $('#collection-holder').find('.c-form-input-txt').text('');
      $(this).removeClass('is-active');
    });
  }

};


function FileUploader(element){

}



module.exports = Form;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_fa.js
// module id = 6
// module chunks = 0